import React from "react"
import PropTypes from "prop-types"
import {Button, Col, Row, Table, Icon, Tooltip} from "antd"

export default class LovResultTable extends React.Component {

    static propTypes = {
        mappings: PropTypes.array.isRequired,
        gettingMapping: PropTypes.bool.isRequired,
        handleRemove: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        saveMapping: PropTypes.func.isRequired,
        selectedCode: PropTypes.string,
        saving: PropTypes.bool.isRequired,
        handleGlobalTypeChange: PropTypes.func.isRequired
    };

    render() {
        const {mappings, gettingMapping, handleRemove, title, saveMapping, selectedCode, saving, handleGlobalTypeChange} = this.props;
        const columns = [
            {
                title: 'Type',
                dataIndex: 'type',
                render: (type, record) => <a onClick={() => handleGlobalTypeChange(type)}>{type}</a>
            },
            {title: 'Label', dataIndex: 'label'},
            {title: 'Code', dataIndex: 'code'},
            {title: '', render: (text, record) => <Button onClick={() => handleRemove(record)} icon="close"/>}
        ];
        const disable = selectedCode === null;
        function refreshPage(){
            window.location.reload();
        }



        return <div>
            <Row>
                <Col span={6}>
                    <div className="apb-ui-tooltips">
                        <h4>{title}</h4>
                        <Tooltip title="See results">
                            <span><Icon type="question-circle-o"/></span>
                        </Tooltip>
                    </div>
                </Col>
                <Col span={20}>
                    <Table loading={gettingMapping || saving}
                           rowKey={r => r.type + r.code}
                           columns={columns}
                           dataSource={mappings}
                    />
                </Col>


                <Col span={20}>
                    <div className="lov-button-save-mapper">

                        <Button type="primary" onClick={saveMapping} disabled={disable}>Save</Button>
                        <Button onClick={ refreshPage } disabled={disable}>Cancel</Button>
                    </div>
                </Col>
            </Row>

        </div>
    }

}


// WEBPACK FOOTER //
// ./src/js/lovs/map/LovResultTable.js